import DiagnosticsModule from '@modules/DiagnosticsModule';
import {
  RTCSMetricNames,
  RTCSMetricTags,
  RTCSEventType,
} from '../../metrics/rtcsMetrics';

/**
 * Tracks RTCS event latency from server send time to client receive time.
 * Silently fails if metric recording throws to prevent business logic disruption.
 *
 * @param timestamp - Server send timestamp (number in ms or ISO string)
 * @param eventType - RTCS event type from RTCSEventType constants
 */
export function trackRTCSEventLatency(
  timestamp: string | number | undefined,
  eventType: (typeof RTCSEventType)[keyof typeof RTCSEventType],
): void {
  if (!timestamp) return;

  try {
    const clientReceiveTime = Date.now();
    const serverSendTime =
      typeof timestamp === 'number' ? timestamp : Date.parse(timestamp);
    const latencyMs = clientReceiveTime - serverSendTime;

    if (latencyMs >= 0 && !isNaN(latencyMs)) {
      DiagnosticsModule.recordHistogram(
        RTCSMetricNames.RTCS_EVENT_LATENCY_DURATION,
        latencyMs,
        {
          [RTCSMetricTags.EVENT_TYPE]: eventType,
        },
      );
    }
  } catch (error) {
    // Silently fail - metrics are non-critical
    // DiagnosticsModule already logs errors internally
    console.warn('Failed to track RTCS event latency:', error);
  }
}
